<template>
  <div>

    <div
      id="login"
      v-if="isCustom && !isMobile && custom == 'xugong'"
      v-loading="loading"
      element-loading-text="正在登录"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <div class="logintop xugong">
        <div class="ltbg">
          <div class="lttop xugonglogo">
            <img src="@/assets/custom/xg-logo.png" width="167" height="36" alt />
          </div>
          <div class="ltbottom">
            <!-- 轮播图 -->
            <div class="describe">
              <h2>轻松管理数据资源</h2>
              <p>
                快人一步的云端数据资源解决方案快人一步的云端数据解决方案
              </p>
            </div>
            <!-- 登录 -->
            <!-- 登录按钮点击一下之后1s之内为灰色 -->
            <div v-show="isForget && !isbang" class="loginbg">
              <div class="header">
                <p :class="!iswx ? 'active' : ''" @click="userLogin">账户登录</p>
                <p :class="iswx ? 'active' : ''" v-if="isZjw" @click="userLogin">扫码登录</p>
              </div>
              <div class="justlogin" v-if="!iswx">
                <el-form :rules="rule1" ref="user" :model="user">
                  <el-form-item prop="username">
                    <el-input
                      size="large"
                      class="elinput"
                      placeholder="邮箱 / 手机"
                      @keyup.enter.native="loginClick('user')"
                      v-model="user.username"
                    >
                      <img
                        slot="prefix"
                        width="20px"
                        height="20px"
                        src="@/assets/login/userimg.png"
                        alt
                      />
                    </el-input>
                  </el-form-item>

                  <!-- 用于不然input记住账号
                  <el-input
                    size="large"
                    class="elinput"
                    style="position:fixed;bottom:-9999px;">
                    <img slot="prefix" width="20px" height="20px" src="@/assets/login/userimg.png" alt="">
                  </el-input>
                  用于不然input记住密码
                  <el-input
                    size="large"
                    class="elinput"
                    show-password
                    style="position:fixed;bottom:-9999px;">
                    <img slot="prefix" width="20px" height="20px" src="@/assets/login/pwimg.png" alt="">
                  </el-input>-->
                  <el-form-item prop="psw">
                    <el-input
                      size="large"
                      class="elinput"
                      placeholder="密码口令"
                      show-password
                      @keyup.enter.native="loginClick('user')"
                      v-model="user.psw"
                    >
                      <img
                        slot="prefix"
                        width="20px"
                        height="20px"
                        src="@/assets/login/pwimg.png"
                        alt
                      />
                    </el-input>
                  </el-form-item>

                  <el-form-item>
                    <el-button
                      @click="loginClick('user')"
                      ref="loginref"
                      :loading="loginLoading"
                      class="btn xugonglogin"
                    >{{ loginText }}</el-button>
                  </el-form-item>
                </el-form>

                <div class="msg">
                  <div v-if="errorFlag" class="error">
                    <img src="@/assets/login/error.png" width="16px" height="16px" alt />
                    <div>密码或用户名错误</div>
                  </div>

                  <div v-if="noLoginFlag" class="error">
                    <img src="@/assets/login/error.png" width="16px" height="16px" alt />
                    <div>很抱歉，您没有登录权限</div>
                  </div>

                  <div v-if="!iswx" class="forgetpsw" style="text-align:left;">
                    <div @click="changeForget">忘记密码?</div>
                  </div>
                </div>

                <div v-if="iswx" class="msg noerror">
                  <div class="forgetpsw">
                    <div @click="changeForget">忘记密码?</div>
                  </div>
                </div>
              </div>

              <div class="justwx" v-if="iswx">
                <div class="weixinbj">
                  <img src="@/assets/login/wx.png" alt />
                  <span>微信登录</span>
                </div>

                <div class="wx_dialog_toiast">
                  <!-- 承载二维码容器 -->
                  <div class="wx_dialog_toiast_delltet" id="loginContainer"></div>
                  <div class="wx_dialog_button_delete" @click="close_wchat_qrcode">
                    <i class="el-icon-circle-close" style="color: red; font-size: 70px"></i>
                  </div>
                </div>
              </div>
            </div>

            <!-- 绑定手机号 -->
            <div v-show="isbang" class="loginbg">
              <div class="header">
                <p class="active">绑定账号</p>
              </div>
              <div class="justlogin">
                <el-form :rules="rule1" ref="user" :model="user">
                  <el-form-item prop="username">
                    <el-input
                      size="large"
                      class="elinput"
                      placeholder="邮箱 / 手机"
                      @keyup.enter.native="loginClick('user')"
                      v-model="user.username"
                    >
                      <img
                        slot="prefix"
                        width="20px"
                        height="20px"
                        src="@/assets/login/userimg.png"
                        alt
                      />
                    </el-input>
                  </el-form-item>

                  <el-form-item prop="psw">
                    <el-input
                      size="large"
                      class="elinput"
                      placeholder="密码口令"
                      show-password
                      @keyup.enter.native="loginClick('user')"
                      v-model="user.psw"
                    >
                      <img
                        slot="prefix"
                        width="20px"
                        height="20px"
                        src="@/assets/login/pwimg.png"
                        alt
                      />
                    </el-input>
                  </el-form-item>

                  <el-form-item>
                    <el-button
                      @click="bangLoginClick('user')"
                      ref="loginref"
                      :loading="loginLoading"
                      class="btn"
                    >{{ '确定绑定' }}</el-button>
                  </el-form-item>
                </el-form>

                <div class="msg">
                  <div @click="goBack" class="forgetpsw">
                    <div>返回</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 忘记密码 -->
            <div v-show="!isForget" class="loginbg">
              <p>忘记密码</p>
              <el-form :rules="rule2" ref="userforget" :model="userforget">
                <el-form-item prop="usernameforget">
                  <el-input
                    size="large"
                    class="elinput forgetinput"
                    placeholder="请输入手机号"
                    v-model="userforget.usernameforget"
                  >
                    <img
                      slot="prefix"
                      width="20px"
                      height="20px"
                      src="@/assets/login/userimg.png"
                      alt
                    />
                    <el-button
                      slot="suffix"
                      v-popover:popover
                      @click="getVcode(userforget.usernameforget)"
                      class="vcode"
                    >{{ loginCode }}</el-button>
                  </el-input>

                  <el-popover
                    placement="top-start"
                    width="320"
                    trigger="manual"
                    v-model="vantDia"
                    @hide="hideVantDia"
                    @show="showVantDia"
                  >
                    <div>
                      <slide-verify
                        ref="slideblock"
                        @again="onAgain"
                        @fulfilled="onFulfilled"
                        @success="onSuccess"
                        @fail="onFail"
                        @refresh="onRefresh"
                        :accuracy="8"
                        :slider-text="text"
                        :w="320"
                      ></slide-verify>
                    </div>
                    <!-- <el-button style="top:10px;" :disabled="showVantDia" slot="reference"  @click="getVcode(registerUser.mobile,1)" v-popover:popover class="vcode">{{loginCode}}</el-button> -->
                  </el-popover>
                </el-form-item>
                <el-form-item prop="pswforget">
                  <el-input
                    size="large"
                    class="elinput forgetinput"
                    placeholder="请输入验证码"
                    v-model="userforget.pswforget"
                  >
                    <img
                      slot="prefix"
                      width="20px"
                      height="20px"
                      src="@/assets/login/pwimg.png"
                      alt
                    />
                  </el-input>
                </el-form-item>
                <el-form-item prop="pswsureforget">
                  <el-input
                    size="large"
                    class="elinput forgetinput"
                    placeholder="请输入密码"
                    show-password
                    v-model="userforget.pswsureforget"
                  >
                    <img
                      slot="prefix"
                      width="20px"
                      height="20px"
                      src="@/assets/login/pwimg.png"
                      alt
                    />
                  </el-input>
                </el-form-item>
                <el-form-item>
                  <button class="btn" @click.prevent="changePsw('userforget')">确定</button>
                </el-form-item>
              </el-form>
              <div class="msg noerror">
                <div class="forgetpsw">
                  <div @click="changeForget">返回登录</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="loginbottom">
        <div class="lbtop">
          <div v-for="(e,i) in lbtoplist" :key="i" class="lbtoplist">
            <div>
              <img :src="e.imgsrc" height="60px" width="60px" alt />
              <p>{{ e.p1 }}</p>
              <p>{{ e.p2 }}</p>
            </div>
            <div v-if="i < 3" class="line"></div>
          </div>
        </div>
        <div class="lbbottom">
          <p>版权所有   徐工集团工程机械有限公司 © 2021 </p>
          <p>苏ICP备10206335号-2</p>
        </div>
      </div>
    </div>

    <div
      id="login"
      v-if="isCustom && !isMobile && custom == 'weichuang'"
      v-loading="loading"
      element-loading-text="正在登录"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <div class="logintop weichuang">
        <div class="ltbg">
          <div class="lttop xugonglogo">
            <img src="@/assets/custom/wc-logo.png" width="278" height="40" alt />
          </div>
          <div class="ltbottom">
            <!-- 轮播图 -->
            <div class="describe wc">
              <h2>轻松管理数据资源</h2>
              <p>
                快人一步的云端数据资源解决方案快人一步的云端数据解决方案
              </p>
            </div>
            <!-- 登录 -->
            <!-- 登录按钮点击一下之后1s之内为灰色 -->
            <div v-show="isForget && !isbang" class="loginbg">
              <div class="header">
                <p :class="!iswx ? 'active' : ''" @click="userLogin">账户登录</p>
                <p :class="iswx ? 'active' : ''" v-if="isZjw" @click="userLogin">扫码登录</p>
              </div>
              <div class="justlogin" v-if="!iswx">
                <el-form :rules="rule1" ref="user" :model="user">
                  <el-form-item prop="username">
                    <el-input
                      size="large"
                      class="elinput"
                      placeholder="邮箱 / 手机"
                      @keyup.enter.native="loginClick('user')"
                      v-model="user.username"
                    >
                      <img
                        slot="prefix"
                        width="20px"
                        height="20px"
                        src="@/assets/login/userimg.png"
                        alt
                      />
                    </el-input>
                  </el-form-item>

                  <!-- 用于不然input记住账号
                  <el-input
                    size="large"
                    class="elinput"
                    style="position:fixed;bottom:-9999px;">
                    <img slot="prefix" width="20px" height="20px" src="@/assets/login/userimg.png" alt="">
                  </el-input>
                  用于不然input记住密码
                  <el-input
                    size="large"
                    class="elinput"
                    show-password
                    style="position:fixed;bottom:-9999px;">
                    <img slot="prefix" width="20px" height="20px" src="@/assets/login/pwimg.png" alt="">
                  </el-input>-->
                  <el-form-item prop="psw">
                    <el-input
                      size="large"
                      class="elinput"
                      placeholder="密码口令"
                      show-password
                      @keyup.enter.native="loginClick('user')"
                      v-model="user.psw"
                    >
                      <img
                        slot="prefix"
                        width="20px"
                        height="20px"
                        src="@/assets/login/pwimg.png"
                        alt
                      />
                    </el-input>
                  </el-form-item>

                  <el-form-item>
                    <el-button
                      @click="loginClick('user')"
                      ref="loginref"
                      :loading="loginLoading"
                      class="btn wclogin"
                    >{{ loginText }}</el-button>
                  </el-form-item>
                </el-form>

                <div class="msg">
                  <div v-if="errorFlag" class="error">
                    <img src="@/assets/login/error.png" width="16px" height="16px" alt />
                    <div>密码或用户名错误</div>
                  </div>

                  <div v-if="noLoginFlag" class="error">
                    <img src="@/assets/login/error.png" width="16px" height="16px" alt />
                    <div>很抱歉，您没有登录权限</div>
                  </div>

                  <div v-if="!iswx" class="forgetpsw" style="text-align:left;">
                    <div @click="changeForget">忘记密码?</div>
                  </div>
                </div>

                <div v-if="iswx" class="msg noerror">
                  <div class="forgetpsw">
                    <div @click="changeForget">忘记密码?</div>
                  </div>
                </div>
              </div>

              <div class="justwx" v-if="iswx">
                <div class="weixinbj">
                  <img src="@/assets/login/wx.png" alt />
                  <span>微信登录</span>
                </div>

                <div class="wx_dialog_toiast">
                  <!-- 承载二维码容器 -->
                  <div class="wx_dialog_toiast_delltet" id="loginContainer"></div>
                  <div class="wx_dialog_button_delete" @click="close_wchat_qrcode">
                    <i class="el-icon-circle-close" style="color: red; font-size: 70px"></i>
                  </div>
                </div>
              </div>
            </div>

            <!-- 绑定手机号 -->
            <div v-show="isbang" class="loginbg">
              <div class="header">
                <p class="active">绑定账号</p>
              </div>
              <div class="justlogin">
                <el-form :rules="rule1" ref="user" :model="user">
                  <el-form-item prop="username">
                    <el-input
                      size="large"
                      class="elinput"
                      placeholder="邮箱 / 手机"
                      @keyup.enter.native="loginClick('user')"
                      v-model="user.username"
                    >
                      <img
                        slot="prefix"
                        width="20px"
                        height="20px"
                        src="@/assets/login/userimg.png"
                        alt
                      />
                    </el-input>
                  </el-form-item>

                  <el-form-item prop="psw">
                    <el-input
                      size="large"
                      class="elinput"
                      placeholder="密码口令"
                      show-password
                      @keyup.enter.native="loginClick('user')"
                      v-model="user.psw"
                    >
                      <img
                        slot="prefix"
                        width="20px"
                        height="20px"
                        src="@/assets/login/pwimg.png"
                        alt
                      />
                    </el-input>
                  </el-form-item>

                  <el-form-item>
                    <el-button
                      @click="bangLoginClick('user')"
                      ref="loginref"
                      :loading="loginLoading"
                      class="btn"
                    >{{ '确定绑定' }}</el-button>
                  </el-form-item>
                </el-form>

                <div class="msg">
                  <div @click="goBack" class="forgetpsw">
                    <div>返回</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 忘记密码 -->
            <div v-show="!isForget" class="loginbg">
              <p>忘记密码</p>
              <el-form :rules="rule2" ref="userforget" :model="userforget">
                <el-form-item prop="usernameforget">
                  <el-input
                    size="large"
                    class="elinput forgetinput"
                    placeholder="请输入手机号"
                    v-model="userforget.usernameforget"
                  >
                    <img
                      slot="prefix"
                      width="20px"
                      height="20px"
                      src="@/assets/login/userimg.png"
                      alt
                    />
                    <el-button
                      slot="suffix"
                      v-popover:popover
                      @click="getVcode(userforget.usernameforget)"
                      class="vcode"
                    >{{ loginCode }}</el-button>
                  </el-input>

                  <el-popover
                    placement="top-start"
                    width="320"
                    trigger="manual"
                    v-model="vantDia"
                    @hide="hideVantDia"
                    @show="showVantDia"
                  >
                    <div>
                      <slide-verify
                        ref="slideblock"
                        @again="onAgain"
                        @fulfilled="onFulfilled"
                        @success="onSuccess"
                        @fail="onFail"
                        @refresh="onRefresh"
                        :accuracy="8"
                        :slider-text="text"
                        :w="320"
                      ></slide-verify>
                    </div>
                    <!-- <el-button style="top:10px;" :disabled="showVantDia" slot="reference"  @click="getVcode(registerUser.mobile,1)" v-popover:popover class="vcode">{{loginCode}}</el-button> -->
                  </el-popover>
                </el-form-item>
                <el-form-item prop="pswforget">
                  <el-input
                    size="large"
                    class="elinput forgetinput"
                    placeholder="请输入验证码"
                    v-model="userforget.pswforget"
                  >
                    <img
                      slot="prefix"
                      width="20px"
                      height="20px"
                      src="@/assets/login/pwimg.png"
                      alt
                    />
                  </el-input>
                </el-form-item>
                <el-form-item prop="pswsureforget">
                  <el-input
                    size="large"
                    class="elinput forgetinput"
                    placeholder="请输入密码"
                    show-password
                    v-model="userforget.pswsureforget"
                  >
                    <img
                      slot="prefix"
                      width="20px"
                      height="20px"
                      src="@/assets/login/pwimg.png"
                      alt
                    />
                  </el-input>
                </el-form-item>
                <el-form-item>
                  <button class="btn" @click.prevent="changePsw('userforget')">确定</button>
                </el-form-item>
              </el-form>
              <div class="msg noerror">
                <div class="forgetpsw">
                  <div @click="changeForget">返回登录</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="loginbottom">
        <div class="lbtop">
          <div v-for="(e,i) in lbtoplist" :key="i" class="lbtoplist">
            <div>
              <img :src="e.imgsrc" height="60px" width="60px" alt />
              <p>{{ e.p1 }}</p>
              <p>{{ e.p2 }}</p>
            </div>
            <div v-if="i < 3" class="line"></div>
          </div>
        </div>
        <div class="lbbottom">
          <p>Copyright 1998-2019, MicroPort Scientific Corporation. All rights reserved</p>
          <p>沪ICP备06056186号      沪公网安备31011502014876号</p>
        </div>
      </div>
    </div>

    <div
      id="login"
      v-if="!isCustom && !simple && !isMobile && custom == ''"
      v-loading="loading"
      element-loading-text="正在登录"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <div class="logintop">
        <div class="ltbg">
          <div class="lttop">
            <img src="@/assets/login/logo.png" width="164px" height="59px" alt />
            <p>技术支持:www.routercn.cn</p>
          </div>
          <div class="ltbottom">
            <!-- 轮播图 -->
            <div class="rotation">
              <img
                :class="isRotation === 1 ? 'img active' : 'img'"
                src="@/assets/login/logins1.png"
                alt
              />
              <img
                :class="isRotation === 0 ? 'img spimg active' : 'img spimg'"
                src="@/assets/login/logins2.png"
                alt
              />
              <ul>
                <li>
                  <img
                    @mouseover="changeRotation1"
                    @mouseout="startRotationInt"
                    v-if="isRotation === 1"
                    src="@/assets/login/ss.png"
                    alt
                  />
                  <img
                    @mouseover="changeRotation1"
                    @mouseout="startRotationInt"
                    v-if="isRotation === 0"
                    src="@/assets/login/sk.png"
                    alt
                  />
                </li>
                <li>
                  <img
                    @mouseover="changeRotation0"
                    @mouseout="startRotationInt"
                    v-if="isRotation === 0"
                    src="@/assets/login/ss.png"
                    alt
                  />
                  <img
                    @mouseover="changeRotation0"
                    @mouseout="startRotationInt"
                    v-if="isRotation === 1"
                    src="@/assets/login/sk.png"
                    alt
                  />
                </li>
              </ul>
            </div>
            <!-- 登录 -->
            <!-- 登录按钮点击一下之后1s之内为灰色 -->
            <div v-show="isForget && !isbang" class="loginbg">
              <div class="header">
                <p :class="!iswx ? 'active' : ''" @click="userLogin">账户登录</p>
                <p :class="iswx ? 'active' : ''" v-if="isZjw" @click="userLogin">扫码登录</p>
              </div>
              <div class="justlogin" v-if="!iswx">
                <el-form :rules="rule1" ref="user" :model="user">
                  <el-form-item prop="username">
                    <el-input
                      size="large"
                      class="elinput"
                      placeholder="邮箱 / 手机"
                      @keyup.enter.native="loginClick('user')"
                      v-model="user.username"
                    >
                      <img
                        slot="prefix"
                        width="20px"
                        height="20px"
                        src="@/assets/login/userimg.png"
                        alt
                      />
                    </el-input>
                  </el-form-item>

                  <!-- 用于不然input记住账号
                  <el-input
                    size="large"
                    class="elinput"
                    style="position:fixed;bottom:-9999px;">
                    <img slot="prefix" width="20px" height="20px" src="@/assets/login/userimg.png" alt="">
                  </el-input>
                  用于不然input记住密码
                  <el-input
                    size="large"
                    class="elinput"
                    show-password
                    style="position:fixed;bottom:-9999px;">
                    <img slot="prefix" width="20px" height="20px" src="@/assets/login/pwimg.png" alt="">
                  </el-input>-->
                  <el-form-item prop="psw">
                    <el-input
                      size="large"
                      class="elinput"
                      placeholder="密码口令"
                      show-password
                      @keyup.enter.native="loginClick('user')"
                      v-model="user.psw"
                    >
                      <img
                        slot="prefix"
                        width="20px"
                        height="20px"
                        src="@/assets/login/pwimg.png"
                        alt
                      />
                    </el-input>
                  </el-form-item>

                  <el-form-item>
                    <el-button
                      @click="loginClick('user')"
                      ref="loginref"
                      :loading="loginLoading"
                      class="btn"
                    >{{ loginText }}</el-button>
                  </el-form-item>
                </el-form>

                <div class="msg">
                  <div v-if="errorFlag" class="error">
                    <img src="@/assets/login/error.png" width="16px" height="16px" alt />
                    <div>密码或用户名错误</div>
                  </div>

                  <div v-if="noLoginFlag" class="error">
                    <img src="@/assets/login/error.png" width="16px" height="16px" alt />
                    <div>很抱歉，您没有登录权限</div>
                  </div>

                  <div v-if="!iswx" class="forgetpsw" style="text-align:left;">
                    <div @click="changeForget">忘记密码?</div>
                  </div>
                </div>

                <div v-if="iswx" class="msg noerror">
                  <div class="forgetpsw">
                    <div @click="changeForget">忘记密码?</div>
                  </div>
                </div>
              </div>

              <div class="justwx" v-if="iswx">
                <div class="weixinbj">
                  <img src="@/assets/login/wx.png" alt />
                  <span>微信登录</span>
                </div>

                <div class="wx_dialog_toiast">
                  <!-- 承载二维码容器 -->
                  <div class="wx_dialog_toiast_delltet" id="loginContainer"></div>
                  <div class="wx_dialog_button_delete" @click="close_wchat_qrcode">
                    <i class="el-icon-circle-close" style="color: red; font-size: 70px"></i>
                  </div>
                </div>
              </div>
            </div>

            <!-- 绑定手机号 -->
            <div v-show="isbang" class="loginbg">
              <div class="header">
                <p class="active">绑定账号</p>
              </div>
              <div class="justlogin">
                <el-form :rules="rule1" ref="user" :model="user">
                  <el-form-item prop="username">
                    <el-input
                      size="large"
                      class="elinput"
                      placeholder="邮箱 / 手机"
                      @keyup.enter.native="loginClick('user')"
                      v-model="user.username"
                    >
                      <img
                        slot="prefix"
                        width="20px"
                        height="20px"
                        src="@/assets/login/userimg.png"
                        alt
                      />
                    </el-input>
                  </el-form-item>

                  <el-form-item prop="psw">
                    <el-input
                      size="large"
                      class="elinput"
                      placeholder="密码口令"
                      show-password
                      @keyup.enter.native="loginClick('user')"
                      v-model="user.psw"
                    >
                      <img
                        slot="prefix"
                        width="20px"
                        height="20px"
                        src="@/assets/login/pwimg.png"
                        alt
                      />
                    </el-input>
                  </el-form-item>

                  <el-form-item>
                    <el-button
                      @click="bangLoginClick('user')"
                      ref="loginref"
                      :loading="loginLoading"
                      class="btn"
                    >{{ '确定绑定' }}</el-button>
                  </el-form-item>
                </el-form>

                <div class="msg">
                  <div @click="goBack" class="forgetpsw">
                    <div>返回</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 忘记密码 -->
            <div v-show="!isForget" class="loginbg">
              <p>忘记密码</p>
              <el-form :rules="rule2" ref="userforget" :model="userforget">
                <el-form-item prop="usernameforget">
                  <el-input
                    size="large"
                    class="elinput forgetinput"
                    placeholder="请输入手机号"
                    v-model="userforget.usernameforget"
                  >
                    <img
                      slot="prefix"
                      width="20px"
                      height="20px"
                      src="@/assets/login/userimg.png"
                      alt
                    />
                    <el-button
                      slot="suffix"
                      v-popover:popover
                      @click="getVcode(userforget.usernameforget)"
                      class="vcode"
                    >{{ loginCode }}</el-button>
                  </el-input>

                  <el-popover
                    placement="top-start"
                    width="320"
                    trigger="manual"
                    v-model="vantDia"
                    @hide="hideVantDia"
                    @show="showVantDia"
                  >
                    <div>
                      <slide-verify
                        ref="slideblock"
                        @again="onAgain"
                        @fulfilled="onFulfilled"
                        @success="onSuccess"
                        @fail="onFail"
                        @refresh="onRefresh"
                        :accuracy="8"
                        :slider-text="text"
                        :w="320"
                      ></slide-verify>
                    </div>
                    <!-- <el-button style="top:10px;" :disabled="showVantDia" slot="reference"  @click="getVcode(registerUser.mobile,1)" v-popover:popover class="vcode">{{loginCode}}</el-button> -->
                  </el-popover>
                </el-form-item>
                <el-form-item prop="pswforget">
                  <el-input
                    size="large"
                    class="elinput forgetinput"
                    placeholder="请输入验证码"
                    v-model="userforget.pswforget"
                  >
                    <img
                      slot="prefix"
                      width="20px"
                      height="20px"
                      src="@/assets/login/pwimg.png"
                      alt
                    />
                  </el-input>
                </el-form-item>
                <el-form-item prop="pswsureforget">
                  <el-input
                    size="large"
                    class="elinput forgetinput"
                    placeholder="请输入密码"
                    show-password
                    v-model="userforget.pswsureforget"
                  >
                    <img
                      slot="prefix"
                      width="20px"
                      height="20px"
                      src="@/assets/login/pwimg.png"
                      alt
                    />
                  </el-input>
                </el-form-item>
                <el-form-item>
                  <button class="btn" @click.prevent="changePsw('userforget')">确定</button>
                </el-form-item>
              </el-form>
              <div class="msg noerror">
                <div class="forgetpsw">
                  <div @click="changeForget">返回登录</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="loginbottom">
        <div class="lbtop">
          <div v-for="(e,i) in lbtoplist" :key="i" class="lbtoplist">
            <div>
              <img :src="e.imgsrc" height="60px" width="60px" alt />
              <p>{{ e.p1 }}</p>
              <p>{{ e.p2 }}</p>
            </div>
            <div v-if="i < 3" class="line"></div>
          </div>
        </div>
        <div class="lbbottom">
          <p>版权所有 © 南京路特软件有限公司 2006-2021</p>
          <p>ICP备08019192号-1</p>
        </div>
      </div>
    </div>

    <div
      id="login"
      v-if="!isCustom && !isMobile && custom == 'xzrb'"
      v-loading="loading"
      element-loading-text="正在登录"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <div class="logintop">
        <div class="ltbg">
          <div class="lttop">
            <img src="@/assets/login/xuzhou.png" width="164px" height="59px" alt />
            <p>技术支持:www.hanfenghao.com</p>
          </div>
          <div class="ltbottom">
            <!-- 轮播图 -->
            <div class="rotation">
              <img
                :class="isRotation === 1 ? 'img active' : 'img'"
                src="@/assets/login/logins1.png"
                alt
              />
              <img
                :class="isRotation === 0 ? 'img spimg active' : 'img spimg'"
                src="@/assets/login/logins2.png"
                alt
              />
              <ul>
                <li>
                  <img
                    @mouseover="changeRotation1"
                    @mouseout="startRotationInt"
                    v-if="isRotation === 1"
                    src="@/assets/login/ss.png"
                    alt
                  />
                  <img
                    @mouseover="changeRotation1"
                    @mouseout="startRotationInt"
                    v-if="isRotation === 0"
                    src="@/assets/login/sk.png"
                    alt
                  />
                </li>
                <li>
                  <img
                    @mouseover="changeRotation0"
                    @mouseout="startRotationInt"
                    v-if="isRotation === 0"
                    src="@/assets/login/ss.png"
                    alt
                  />
                  <img
                    @mouseover="changeRotation0"
                    @mouseout="startRotationInt"
                    v-if="isRotation === 1"
                    src="@/assets/login/sk.png"
                    alt
                  />
                </li>
              </ul>
            </div>
            <!-- 登录 -->
            <!-- 登录按钮点击一下之后1s之内为灰色 -->
            <div v-show="isForget && !isbang" class="loginbg">
              <div class="header">
                <p :class="!iswx ? 'active' : ''" @click="userLogin">账户登录</p>
                <p :class="iswx ? 'active' : ''" v-if="isZjw" @click="userLogin">扫码登录</p>
              </div>
              <div class="justlogin" v-if="!iswx">
                <el-form :rules="rule1" ref="user" :model="user">
                  <el-form-item prop="username">
                    <el-input
                      size="large"
                      class="elinput"
                      placeholder="邮箱 / 手机"
                      @keyup.enter.native="loginClick('user')"
                      v-model="user.username"
                    >
                      <img
                        slot="prefix"
                        width="20px"
                        height="20px"
                        src="@/assets/login/userimg.png"
                        alt
                      />
                    </el-input>
                  </el-form-item>

                  <!-- 用于不然input记住账号
                  <el-input
                    size="large"
                    class="elinput"
                    style="position:fixed;bottom:-9999px;">
                    <img slot="prefix" width="20px" height="20px" src="@/assets/login/userimg.png" alt="">
                  </el-input>
                  用于不然input记住密码
                  <el-input
                    size="large"
                    class="elinput"
                    show-password
                    style="position:fixed;bottom:-9999px;">
                    <img slot="prefix" width="20px" height="20px" src="@/assets/login/pwimg.png" alt="">
                  </el-input>-->
                  <el-form-item prop="psw">
                    <el-input
                      size="large"
                      class="elinput"
                      placeholder="密码口令"
                      show-password
                      @keyup.enter.native="loginClick('user')"
                      v-model="user.psw"
                    >
                      <img
                        slot="prefix"
                        width="20px"
                        height="20px"
                        src="@/assets/login/pwimg.png"
                        alt
                      />
                    </el-input>
                  </el-form-item>

                  <el-form-item>
                    <el-button
                      @click="loginClick('user')"
                      ref="loginref"
                      :loading="loginLoading"
                      class="btn"
                    >{{ loginText }}</el-button>
                  </el-form-item>
                </el-form>

                <div class="msg">
                  <div v-if="errorFlag" class="error">
                    <img src="@/assets/login/error.png" width="16px" height="16px" alt />
                    <div>密码或用户名错误</div>
                  </div>

                  <div v-if="noLoginFlag" class="error">
                    <img src="@/assets/login/error.png" width="16px" height="16px" alt />
                    <div>很抱歉，您没有登录权限</div>
                  </div>

                  <div v-if="!iswx" class="forgetpsw" style="text-align:left;">
                    <div @click="changeForget">忘记密码?</div>
                  </div>
                </div>

                <div v-if="iswx" class="msg noerror">
                  <div class="forgetpsw">
                    <div @click="changeForget">忘记密码?</div>
                  </div>
                </div>
              </div>

              <div class="justwx" v-if="iswx">
                <div class="weixinbj">
                  <img src="@/assets/login/wx.png" alt />
                  <span>微信登录</span>
                </div>

                <div class="wx_dialog_toiast">
                  <!-- 承载二维码容器 -->
                  <div class="wx_dialog_toiast_delltet" id="loginContainer"></div>
                  <div class="wx_dialog_button_delete" @click="close_wchat_qrcode">
                    <i class="el-icon-circle-close" style="color: red; font-size: 70px"></i>
                  </div>
                </div>
              </div>
            </div>

            <!-- 绑定手机号 -->
            <div v-show="isbang" class="loginbg">
              <div class="header">
                <p class="active">绑定账号</p>
              </div>
              <div class="justlogin">
                <el-form :rules="rule1" ref="user" :model="user">
                  <el-form-item prop="username">
                    <el-input
                      size="large"
                      class="elinput"
                      placeholder="邮箱 / 手机"
                      @keyup.enter.native="loginClick('user')"
                      v-model="user.username"
                    >
                      <img
                        slot="prefix"
                        width="20px"
                        height="20px"
                        src="@/assets/login/userimg.png"
                        alt
                      />
                    </el-input>
                  </el-form-item>

                  <el-form-item prop="psw">
                    <el-input
                      size="large"
                      class="elinput"
                      placeholder="密码口令"
                      show-password
                      @keyup.enter.native="loginClick('user')"
                      v-model="user.psw"
                    >
                      <img
                        slot="prefix"
                        width="20px"
                        height="20px"
                        src="@/assets/login/pwimg.png"
                        alt
                      />
                    </el-input>
                  </el-form-item>

                  <el-form-item>
                    <el-button
                      @click="bangLoginClick('user')"
                      ref="loginref"
                      :loading="loginLoading"
                      class="btn"
                    >{{ '确定绑定' }}</el-button>
                  </el-form-item>
                </el-form>

                <div class="msg">
                  <div @click="goBack" class="forgetpsw">
                    <div>返回</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 忘记密码 -->
            <div v-show="!isForget" class="loginbg">
              <p>忘记密码</p>
              <el-form :rules="rule2" ref="userforget" :model="userforget">
                <el-form-item prop="usernameforget">
                  <el-input
                    size="large"
                    class="elinput forgetinput"
                    placeholder="请输入手机号"
                    v-model="userforget.usernameforget"
                  >
                    <img
                      slot="prefix"
                      width="20px"
                      height="20px"
                      src="@/assets/login/userimg.png"
                      alt
                    />
                    <el-button
                      slot="suffix"
                      v-popover:popover
                      @click="getVcode(userforget.usernameforget)"
                      class="vcode"
                    >{{ loginCode }}</el-button>
                  </el-input>

                  <el-popover
                    placement="top-start"
                    width="320"
                    trigger="manual"
                    v-model="vantDia"
                    @hide="hideVantDia"
                    @show="showVantDia"
                  >
                    <div>
                      <slide-verify
                        ref="slideblock"
                        @again="onAgain"
                        @fulfilled="onFulfilled"
                        @success="onSuccess"
                        @fail="onFail"
                        @refresh="onRefresh"
                        :accuracy="8"
                        :slider-text="text"
                        :w="320"
                      ></slide-verify>
                    </div>
                    <!-- <el-button style="top:10px;" :disabled="showVantDia" slot="reference"  @click="getVcode(registerUser.mobile,1)" v-popover:popover class="vcode">{{loginCode}}</el-button> -->
                  </el-popover>
                </el-form-item>
                <el-form-item prop="pswforget">
                  <el-input
                    size="large"
                    class="elinput forgetinput"
                    placeholder="请输入验证码"
                    v-model="userforget.pswforget"
                  >
                    <img
                      slot="prefix"
                      width="20px"
                      height="20px"
                      src="@/assets/login/pwimg.png"
                      alt
                    />
                  </el-input>
                </el-form-item>
                <el-form-item prop="pswsureforget">
                  <el-input
                    size="large"
                    class="elinput forgetinput"
                    placeholder="请输入密码"
                    show-password
                    v-model="userforget.pswsureforget"
                  >
                    <img
                      slot="prefix"
                      width="20px"
                      height="20px"
                      src="@/assets/login/pwimg.png"
                      alt
                    />
                  </el-input>
                </el-form-item>
                <el-form-item>
                  <button class="btn" @click.prevent="changePsw('userforget')">确定</button>
                </el-form-item>
              </el-form>
              <div class="msg noerror">
                <div class="forgetpsw">
                  <div @click="changeForget">返回登录</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="loginbottom">
        <div class="lbtop">
          <div v-for="(e,i) in lbtoplist" :key="i" class="lbtoplist">
            <div>
              <img :src="e.imgsrc" height="60px" width="60px" alt />
              <p>{{ e.p1 }}</p>
              <p>{{ e.p2 }}</p>
            </div>
            <div v-if="i < 3" class="line"></div>
          </div>
        </div>
        <div class="lbbottom">
          <p>版权所有 © 徐州报业网络传播有限公司</p>
          <p>苏ICP备05003658号</p>
        </div>
      </div>
    </div>

    <div v-if="!isCustom && simple && !isMobile" class="simplelogin">
      <div class="content">
        <div class="top">
          <img src="@/assets/simple/logo.png" width="172" alt />
          <p>技术支持: www.routercn.cn</p>
        </div>

        <div class="loginbj">
          <div class="ban">
            <div class="rotation">
              <transition name="el-fade-in-linear">
                <img v-if="isRotation === 1" src="@/assets/simple/ban1.png" alt />
                <img v-if="isRotation === 0" src="@/assets/simple/ban2.png" alt />
              </transition>
              <ul>
                <li>
                  <img
                    @mouseover="changeRotation1"
                    @mouseout="startRotationInt"
                    v-if="isRotation === 1"
                    src="@/assets/login/ss.png"
                    alt
                  />
                  <img
                    @mouseover="changeRotation1"
                    @mouseout="startRotationInt"
                    v-if="isRotation === 0"
                    src="@/assets/login/sk.png"
                    alt
                  />
                </li>
                <li>
                  <img
                    @mouseover="changeRotation0"
                    @mouseout="startRotationInt"
                    v-if="isRotation === 0"
                    src="@/assets/login/ss.png"
                    alt
                  />
                  <img
                    @mouseover="changeRotation0"
                    @mouseout="startRotationInt"
                    v-if="isRotation === 1"
                    src="@/assets/login/sk.png"
                    alt
                  />
                </li>
              </ul>
            </div>
          </div>

          <div class="login">
            <div class="bj">
              <p class="welcom">欢迎登录</p>
              <el-form :rules="rule1" ref="user" :model="user">
                <el-form-item prop="username">
                  <el-input
                    size="large"
                    class="elinput"
                    placeholder="请输入账号"
                    @keyup.enter.native="loginClick('user')"
                    v-model="user.username"
                  >
                    <img
                      slot="prefix"
                      width="20px"
                      height="20px"
                      src="@/assets/simple/user.png"
                      alt
                    />
                  </el-input>
                </el-form-item>

                <el-form-item prop="psw">
                  <el-input
                    size="large"
                    class="elinput"
                    placeholder="请输入密码"
                    show-password
                    @keyup.enter.native="loginClick('user')"
                    v-model="user.psw"
                  >
                    <img slot="prefix" width="20px" height="20px" src="@/assets/simple/psw.png" alt />
                  </el-input>
                </el-form-item>

                <el-form-item>
                  <el-button
                    @click="loginClick('user')"
                    ref="loginref"
                    :loading="loginLoading"
                    class="btn"
                  >{{ loginText }}</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>

        <div class="bottom">
          <p>版权所有 © 南京路特软件有限公司 2006-2021</p>
          <p>ICP备08019192号-1</p>
        </div>
      </div>
    </div>

    <div v-if="isMobile" class="mobilesimple">
      <div class="loginbj">
        <img class="logo" v-if="!simple" src="@/assets/login/yunzhiLogo.png" alt />
        <img class="logo" v-if="simple" src="@/assets/simple/logo-m.png" alt />

        <el-form :rules="rule1" ref="user" :model="user">
          <el-form-item prop="username">
            <el-input
              size="large"
              class="elinput"
              placeholder="请输入账号"
              @keyup.enter.native="loginClick('user')"
              v-model="user.username"
            >
              <img slot="prefix" width="20px" height="20px" src="@/assets/simple/user-m.png" alt />
            </el-input>
          </el-form-item>
          <el-form-item prop="psw">
            <el-input
              size="large"
              class="elinput"
              placeholder="请输入密码"
              show-password
              @keyup.enter.native="loginClick('user')"
              v-model="user.psw"
            >
              <img slot="prefix" width="20px" height="20px" src="@/assets/simple/psw-m.png" alt />
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              @click="loginClick('user')"
              ref="loginref"
              :loading="loginLoading"
              class="btn"
              :style="simple ? ' background: #fd9112;' : ' background: #185ed3;'"
            >{{ loginText }}</el-button>
          </el-form-item>
        </el-form>

        <div class="wx" v-if="isWx">
          <div style="margin-top:12vw;">
            <img src="@/assets/login/wxh.png" alt="">
          </div>
          <div style="margin-top:4vw;">
            <img @click="gowx" src="@/assets/login/mwx.png" alt="">
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapActions } from "vuex";
import { getUserToken } from '@/api/user'
import { listLib } from '@/api/lib'
import { smsVerificationCode, resetPassword, scan, bind ,getAppSecurityConfig } from "@/api/open";
import getIsSimple from '@/constants/simple'
import { Notify } from 'vant';

export default {

  data() {
    // <!--二次验证密码-->
    let validatePass = (rule, value, callback) => {
      if (value !== this.userforget.pswforget) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      isZjw:false,

      openID: '',
      isbang: false,

      iswx: false,
      getIsSimple,
      simple: true,

      errorFlag: false,
      noLoginFlag: false,
      loginText: '登录',
      loginLoading: false,
      loading: false,
      isRotation: 1,
      isForget: true,
      user: {
        username: '',
        psw: ''
      },
      rule1: {
        username: [
          { required: true, message: '请输入邮箱/手机', trigger: 'blur' },
        ],
        psw: [
          { required: true, message: '请输入密码', trigger: 'blur' },
        ]
      },
      userforget: {
        usernameforget: '',
        pswforget: '',
        pswsureforget: ''
      },
      rule2: {
        usernameforget: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
        ],
        pswforget: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
        ],
        pswsureforget: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },

      rotationset: '',
      lbtoplist: [
        {
          imgsrc: require('@/assets/login/loginb1.png'),
          p1: '急速访问',
          p2: 'BGP四线路高速带宽'
        }, {
          imgsrc: require('@/assets/login/loginb2.png'),
          p1: '多点备份',
          p2: '图片多地点实时备份'
        }, {
          imgsrc: require('@/assets/login/loginb3.png'),
          p1: '多维管理',
          p2: '云标签多维度管理照片'
        }, {
          imgsrc: require('@/assets/login/loginb4.png'),
          p1: '人脸识别',
          p2: '智能化归档及识图搜索'
        }
      ],


      isMobile: false,


      // 验证码相关
      msg: '',
      text: '拖动左边滑块完成上方拼图',
      // 精确度小，可允许的误差范围小；为1时，则表示滑块要与凹槽完全重叠，才能验证成功。默认值为5
      accuracy: 1,
      vantDia: false,
      loginCode: "获取验证码",
      vCodetime: 0,
      resetPswPhone: '',
      resetPswCodeKey: '',
      isVantDia: false,


      //判断强弱密码
      insideLoginConfig:'weak',


      isWx:false,
    }
  },
  methods: {
    ...mapActions(["setLoginInfo"]),
    ...mapActions(["setRoleCode"]),
    ...mapActions(["setToken"]),
    ...mapActions(["setCreateUid"]),
    ...mapActions(["setPowers"]),

    gowx(){
      wx.miniProgram.navigateTo({
        url: '/pages/mine/mine'
      })
    },

    userLogin() {
      // console.log(encodeURIComponent('http://10.10.0.104:1199/wechat/auth'));
      if(this.isZjw){
        this.iswx = !this.iswx
        if (this.iswx) {
          this.$nextTick(() => {
            this.get_wx_qrcode()
          })
        }
      }
      
    },

    //weixin
    close_wchat_qrcode() { },

    get_wx_qrcode() {
      var obj = new WxLogin({
        self_redirect: false,
        id: "loginContainer",
        appid: "wxfaa075e20cb4a689",
        scope: "snsapi_login",
        redirect_uri: encodeURIComponent('http://via.jschina.com.cn/loginNoToken'),  //回调域名
        state: Math.ceil(Math.random() * 1000),
        style: "black",
        href: 'data:text/css;base64,QGNoYXJzZXQgIlVURi04IjsKLmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDEzMHB4O30KLmltcG93ZXJCb3ggLnRpdGxlIHtkaXNwbGF5OiBub25lO30KLmltcG93ZXJCb3ggLmluZm8ge3dpZHRoOiAxMzBweDt9Ci5zdGF0dXNfaWNvbiB7ZGlzcGxheTogbm9uZX0KLmltcG93ZXJCb3ggLnN0YXR1cyB7dGV4dC1hbGlnbjogY2VudGVyO30gCg=='
        // href:'data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDIwMHB4O30NCi5pbXBvd2VyQm94IC50aXRsZSB7ZGlzcGxheTogbm9uZTt9DQouaW1wb3dlckJveCAuaW5mbyB7d2lkdGg6IDIwMHB4O30NCi5zdGF0dXNfaWNvbiB7ZGlzcGxheTogbm9uZX0NCi5pbXBvd2VyQm94IC5zdGF0dXMge3RleHQtYWxpZ246IGNlbnRlcjt9'
      })

      // this.scanAsync({
      //   code:'081VRyll2HPMr74Zbfol23aIUJ1VRylq'
      // })
    },


    //获取openid值
    async scanAsync(val) {
      let { status, data, message, errors } = await scan(val);
      if (status) {
        this.setLoginInfo(data)
        this.setToken(data.token)
        this.setCreateUid(data.id)

        localStorage.setItem('token', JSON.stringify(data.token))
        localStorage.setItem('createUid', data.id)
        let libData = await listLib({ pageSize: 200 });
        let libList = []
        if (libData.status) {
          for (let i = 0; i < libData.data.length; i++) {
            if (libData.data[i].status === 1) {
              libList.push('lib-' + libData.data[i].id)
              if(libData.data[i].children.length > 0){
                for (let j = 0; j < libData.data[i].children.length; j++) {
                  libList.push('lib-' + libData.data[i].id + '-' + libData.data[i].children[j].id)
                }
              }
            }
          }
        } else {
          if (this.isMobile) {
            Notify({ type: 'danger', message: libData.message });
          } else {
            this.$message.error(libData.message)
          }
        }
        if (data.powers[0] === 'admin') {
          let powersMy = [
            'allowLogin',
            'mySetting',
            'desktopAuthor',
            'appointPictureNeed',
            'browseUnPicture',
            'allowMyGallery',
            'createAtlas',
            'openLocalDisk',
            'allowGalleryCenter',
            'advSearchPicture',
            'baseSearchPicture',
            'selectPicture',
            'allowApply',
            'pictureDownload',
            'picturePush',
            'pictureShare',
            'allowTransmit',
            'browseDownload',
            'browsePush',
            'browseShare',
            'allowGather',
            'manageAllPictureActivity',
            'manageAllPictureNeed',
            'myPictureActivity',
            'myPictureNeed',
            'activityThemeConfig',
            'baseConfig',
            'libConfig',
            'pushConfig',
            'roleConfig',
            'systemLogs',
            'manageAtlas',
            'myFace',
            'browseActivityArticle',
            'manageActivityArticle',
            'manageAllActivityArticle',
            'myAtlas',
            'checkUserAuthInfo',
            'searchUserAuthInfo',
            'outputUserAuthInfo',
            'checkPictureArticle',
            'myPictureArticleFilter',
            'manageAllPictureArticleFilter',
            'outputPictureArticleFilter',
            'checkPictureArticleFilter',
            'rejectPictureArticleFilter',
            'userConfig',
            'textConfig',

            'createPrivateAtlas',
            'createPublicAtlas',

            'allowAiCenter',
            'securityConfig',
            'dataAnalysis',
            'manageIntelligentNode',
            'allowOperationCenter',
            'manageNas',
            'manageThirdPartyAccess',
            'operationCommand',
            'systemLogs',
            'browseWebsiteCarousel',
            'manageWebsiteCarousel',
            'browseWebsiteInfo',
            'manageWebsiteInfo',
            'websiteConfig',
            'allowRecycleBin',
            'deleteCommand',
            'recoveryCommand',
            'resourceLogCenter',
            'allowOperationCustomLabel',
            'customLabelClassConfig',
            'customLabelConfig',
            'justAdmin'
          ]
          let myPowers = powersMy.concat(libList)
          this.setPowers(myPowers)
          if (this.isMobile) {
            this.$router.push('/pictureCenterMobile')
          } else {
            this.judgeFirstPage(myPowers)
          }
        } else {
          this.setPowers(data.powers)
          if (this.isMobile) {
            // console.log(this.$store.state.user.powers);
            this.$router.push('/pictureCenterMobile')
          } else {
            this.judgeFirstPage(data.powers)
          }
        }

        // this.$router.push('/container')
        if (this.isMobile) {
          Notify({ type: 'success', message: '登录成功！' });
        } else {
          this.$message.success('登录成功！')

        }
      } else {
        this.isbang = true
        this.openID = data
        // o0PK45833PjJEWbAAiytiZHuTH2w
      }
    },

    //绑定手机号
    async bindAsync(val) {
      let { status, data, message, errors } = await bind(val);

      if (status) {
        
        this.setLoginInfo(data)
        this.setToken(data.token)
        this.setCreateUid(data.id)

        localStorage.setItem('token', JSON.stringify(data.token))
        localStorage.setItem('createUid', data.id)
        let libData = await listLib({ pageSize: 200 });
        let libList = []
        if (libData.status) {
          for (let i = 0; i < libData.data.length; i++) {
            if (libData.data[i].status === 1) {
              libList.push('lib-' + libData.data[i].id)
              if(libData.data[i].children.length > 0){
                for (let j = 0; j < libData.data[i].children.length; j++) {
                  libList.push('lib-' + libData.data[i].id + '-' + libData.data[i].children[j].id)
                }
              }
            }
          }
        } else {
          if (this.isMobile) {
            Notify({ type: 'danger', message: libData.message });
          } else {
            this.$message.error(libData.message)
          }
        }
        if (data.powers[0] === 'admin') {
          let powersMy = [
            'allowLogin',
            'mySetting',
            'desktopAuthor',
            'appointPictureNeed',
            'browseUnPicture',
            'allowMyGallery',
            'createAtlas',
            'openLocalDisk',
            'allowGalleryCenter',
            'advSearchPicture',
            'baseSearchPicture',
            'selectPicture',
            'allowApply',
            'pictureDownload',
            'picturePush',
            'pictureShare',
            'allowTransmit',
            'browseDownload',
            'browsePush',
            'browseShare',
            'allowGather',
            'manageAllPictureActivity',
            'manageAllPictureNeed',
            'myPictureActivity',
            'myPictureNeed',
            'activityThemeConfig',
            'baseConfig',
            'libConfig',
            'pushConfig',
            'roleConfig',
            'systemLogs',
            'manageAtlas',
            'myFace',
            'browseActivityArticle',
            'manageActivityArticle',
            'manageAllActivityArticle',
            'myAtlas',
            'checkUserAuthInfo',
            'searchUserAuthInfo',
            'outputUserAuthInfo',
            'checkPictureArticle',
            'myPictureArticleFilter',
            'manageAllPictureArticleFilter',
            'outputPictureArticleFilter',
            'checkPictureArticleFilter',
            'rejectPictureArticleFilter',
            'userConfig',
            'textConfig',

            'createPrivateAtlas',
            'createPublicAtlas',

            'allowAiCenter',
            'securityConfig',
            'dataAnalysis',
            'manageIntelligentNode',
            'allowOperationCenter',
            'manageNas',
            'manageThirdPartyAccess',
            'operationCommand',
            'systemLogs',
            'browseWebsiteCarousel',
            'manageWebsiteCarousel',
            'browseWebsiteInfo',
            'manageWebsiteInfo',
            'websiteConfig',
            'allowRecycleBin',
            'deleteCommand',
            'resourceLogCenter',
            'recoveryCommand',
            'ssoConfig',
            'allowOperationCustomLabel',
            'customLabelClassConfig',
            'customLabelConfig',
            'justAdmin'
          ]
          let myPowers = powersMy.concat(libList)
          this.setPowers(myPowers)
          if (this.isMobile) {
            this.$router.push('/pictureCenterMobile')
          } else {
            this.judgeFirstPage(myPowers)
          }
        } else {
          this.setPowers(data.powers)
          if (this.isMobile) {
            // console.log(this.$store.state.user.powers);
            this.$router.push('/pictureCenterMobile')
          } else {
            this.judgeFirstPage(data.powers)
          }
        }

        // this.$router.push('/container')
        if (this.isMobile) {
          Notify({ type: 'success', message: '登录成功！' });
        } else {
          this.$message.success('登录成功！')

        }
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    getSimple() {
      this.simple = this.isSimple
      // getIsSimple().then(res => {
      //   console.log('isSimple', res);
      //   if (typeof (res) !== "undefined") {
      //     this.simple = res
      //   } else {
      //     this.simple = true
      //   }
      // })
    },

    getBrowser() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    },

    //验证码相关
    hideVantDia() {
      setTimeout(() => {
        if (this.vCodetime == 0 || this.vCodetime == 6) {
          this.isVantDia = false
        } else {
          this.isVantDia = true
        }
      }, 1000);
    },
    showVantDia() {
      // this.isVantDia = true
    },

    onSuccess(times) {
      // console.log(times);
      // console.log('验证通过，耗时 '+ times + '毫秒');
      this.msg = 'login success, 耗时${(times / 1000).toFixed(1)}s'
      this.isVantDia = true
      setTimeout(() => {
        this.vantDia = false
      }, 1000);
      let parmas = {
        phone: this.resetPswPhone
      }
      this.smsVerificationCodeAsync(parmas)
    },
    onFail() {
      this.onRefresh()
      this.msg = ''
    },
    onRefresh() {
      console.log('点击了刷新小图标');
      this.msg = ''
    },
    onFulfilled() {
      console.log('刷新成功啦！');
    },
    onAgain() {
      console.log('检测到非人为操作的哦！');
      this.msg = 'try again';
      // 刷新
      this.$refs.slideblock.reset();
    },


    changeForget() {
      this.isForget = !this.isForget
    },
    changeRotation0() {
      this.isRotation = 0
      // console.log(this.isRotation)
      clearInterval(this.rotationset)
    },
    changeRotation1() {
      this.isRotation = 1
      // console.log(this.isRotation)
      clearInterval(this.rotationset)
    },
    rotationInt() {
      this.rotationset = setInterval(() => {
        if (this.isRotation === 0) {
          this.isRotation = 1
        } else {
          this.isRotation = 0
        }
      }, 4000)
    },
    startRotationInt() {
      this.rotationInt()
    },
    loginClick(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {



          this.loginLoading = true //打开loading
          this.loginText = "正在登录中……"
          this.$refs.loginref.className = 'btn btnclick' //修改登录按钮的样式
          setTimeout(() => {
            this.setRoleCode('1')
            // this.setLoginInfo('账号：'+this.user.username+';密码：'+this.user.psw)

            let pswMD5 = this.$md5(this.user.psw.trim())
            let val = {
              password: pswMD5,
              userName: this.user.username.trim()
            }
            this.getTokenAsync(val)


            // 
            this.loginLoading = false
            this.$refs.loginref.className = 'btn'
            this.loginText = "登录"





          }, 1000);

        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    goBack() {
      this.isbang = false
      this.user.psw = ''
      this.user.username = ''
    },

    bangLoginClick(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.loginLoading = true //打开loading
          this.$refs.loginref.className = 'btn btnclick' //修改登录按钮的样式
          setTimeout(() => {
            this.setRoleCode('1')

            let pswMD5 = this.$md5(this.user.psw.trim())
            let val = {
              password: pswMD5,
              username: this.user.username.trim(),
              openid: this.openID
            }
            this.bindAsync(val)
            // 
            this.loginLoading = false
            this.$refs.loginref.className = 'btn'

          }, 1000);

        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    //获取验证码
    getVcode(v) {
      // console.log(v);
      if (!v) {
        if (this.isMobile) {
          Notify({ type: 'warning', message: '请输入手机号！' });
        } else {
          this.$message.warning('请输入手机号！')
        }
        return false;
      }
      if (!Number.isInteger(Number(v)) && Number(v) < 0) {
        return false;
      }

      if (v.length != 11) {
        return false;
      }
      if (this.loginCode.indexOf('重试') !== -1) {
        return false
      }

      this.resetPswPhone = v
      this.vantDia = !this.vantDia
      // console.log(this.twoCode);
    },

    //更改密码事件
    changePsw(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          let parmas = {
            codeKey: this.resetPswCodeKey,
            codeValue: this.userforget.pswforget,
            mobile: this.userforget.usernameforget,
            password: this.$md5(this.userforget.pswsureforget)
          }
          this.resetPasswordAsync(parmas);
        } else {
          return false;
        }
      });
    },
    handleClickCode() {
      // 父组件直接可以调用刷新方法
      this.$refs.slideblock.reset();
    },

    //判断初次登陆的访问页面
    judgeFirstPage(val) {
      if (val.indexOf('desktopAuthor') !== -1) {
        this.$router.push('/container')
        localStorage.setItem('firstPage', '/container')
      } else if (val.indexOf('desktopEditor') !== -1) {
        this.$router.push('/desktop/editor')
        localStorage.setItem('firstPage', '/desktop/editor')

      } else if (val.indexOf('desktopManager') !== -1) {
        this.$router.push('/desktop/manager')
        localStorage.setItem('firstPage', '/desktop/manager')

      } else if (val.indexOf('allowMyGallery') !== -1 && (val.indexOf('myAtlas') !== -1 || val.indexOf('browseUnPicture') !== -1)) {
        if (val.indexOf('myAtlas') !== -1) {
          this.$router.push('/myLib/myAtlas')
          localStorage.setItem('firstPage', '/myLib/myAtlas')
        } else if (val.indexOf('browseUnPicture') !== -1) {
          this.$router.push('/myLib/unClutteredPicture')
          localStorage.setItem('firstPage', '/myLib/unClutteredPicture')
        }


      } else if (val.indexOf('allowGalleryCenter') !== -1) {
        this.$router.push('/pictureCenter')
        localStorage.setItem('firstPage', '/pictureCenter')

      } else if (val.indexOf('allowGather') !== -1 && (val.indexOf('myPictureNeed') !== -1 || val.indexOf('myPictureActivity') !== -1)) {
        if (val.indexOf('myPictureNeed') !== -1) {
          this.$router.push('/pictureNeed/manage')
          localStorage.setItem('firstPage', '/pictureNeed/manage')
        } else if (val.indexOf('myPictureActivity') !== -1)
          this.$router.push('/pictureActivity/manage')
        localStorage.setItem('firstPage', '/pictureActivity/manage')

      } else if (val.indexOf('allowTransmit') !== -1 && val.indexOf('browseShare') !== -1) {
        this.$router.push('/shareAndPush/myShare')
        localStorage.setItem('firstPage', '/shareAndPush/myShare')

      } else if (val.indexOf('allowTransmit') !== -1 && val.indexOf('browsePush') !== -1) {
        this.$router.push('/shareAndPush/myPush')
        localStorage.setItem('firstPage', '/shareAndPush/myPush')

      } else if (val.indexOf('allowTransmit') !== -1 && val.indexOf('browseDownload') !== -1) {
        this.$router.push('/shareAndPush/myDownload')
        localStorage.setItem('firstPage', '/shareAndPush/myDownload')

      } else if (val.indexOf('checkUserAuthInfo') !== -1) {
        this.$router.push('/workflow/userAuth')
        localStorage.setItem('firstPage', '/workflow/userAuth')
      } else if (val.indexOf('checkPictureArticle') !== -1) {
        this.$router.push('/workflow/activityChoose')
        localStorage.setItem('firstPage', '/workflow/activityChoose')
      } else if (val.indexOf('browseWebsiteCarousel') !== -1) {
        this.$router.push('/workflow/picChoose')
        localStorage.setItem('firstPage', '/workflow/picChoose')
      }
      else if (val.indexOf('allowAiCenter') !== -1 && (val.indexOf('dataAnalysis') !== -1 || val.indexOf('manageIntelligentNode') !== -1)) {
        if (val.indexOf('dataAnalysis') !== -1) {
          this.$router.push('/digitalCenter/dataAnalysis')
          localStorage.setItem('firstPage', '/digitalCenter/dataAnalysis')
        } else if (val.indexOf('manageIntelligentNode') !== -1) {
          this.$router.push('/digitalCenter/smartCenter')
          localStorage.setItem('firstPage', '/digitalCenter/smartCenter')
        }
      } else if (val.indexOf('allowOperationCenter') !== -1 && (val.indexOf('manageNas') !== -1 || val.indexOf('manageThirdPartyAccess') !== -1 || val.indexOf('operationCommand') !== -1 || val.indexOf('systemLogs') !== -1)) {
        if (val.indexOf('manageNas') !== -1) {
          this.$router.push('/operationManage/shareManage')
          localStorage.setItem('firstPage', '/operationManage/shareManage')
        } else if (val.indexOf('manageThirdPartyAccess') !== -1) {
          this.$router.push('/operationManage/thirdAccess')
          localStorage.setItem('firstPage', '/operationManage/thirdAccess')
        } else if (val.indexOf('operationCommand') !== -1) {
          this.$router.push('/config/platform')
          localStorage.setItem('firstPage', '/config/platform')
        } else if (val.indexOf('systemLogs') !== -1) {
          this.$router.push('/config/journalManage')
          localStorage.setItem('firstPage', '/config/journalManage')
        }
      }
      else if (val.indexOf('baseConfig') !== -1) {
        this.$router.push('/config/basic')
        localStorage.setItem('firstPage', '/desktop/manager')

      } else if (val.indexOf('libConfig') !== -1) {
        this.$router.push('/config/picManage')
        localStorage.setItem('firstPage', '/config/picManage')

      } else if (val.indexOf('roleConfig') !== -1) {
        this.$router.push('/config/roleManage')
        localStorage.setItem('firstPage', '/config/roleManage')

      } else if (val.indexOf('userConfig') !== -1) {
        this.$router.push('/config/userManage')
        localStorage.setItem('firstPage', '/config/userManage')

      } else if (val.indexOf('systemLogs') !== -1) {
        this.$router.push('/config/journalManage')
        localStorage.setItem('firstPage', '/config/journalManage')

      } else if (val.indexOf('pushConfig') !== -1) {
        this.$router.push('/config/pushChannelManage')
        localStorage.setItem('firstPage', '/config/pushChannelManage')

      } else if (val.indexOf('activityThemeConfig') !== -1) {
        this.$router.push('/config/activityThemeManage')
        localStorage.setItem('firstPage', '/config/activityThemeManage')
      } else if (val.indexOf('textConfig') !== -1) {
        this.$router.push('/config/appTextConfigManage')
        localStorage.setItem('firstPage', '/config/appTextConfigManage')
      } else if (val.indexOf('websiteConfig') !== -1) {
        this.$router.push('/config/site')
        localStorage.setItem('firstPage', '/config/site')
      } else if (val.indexOf('securityConfig') !== -1) {
        this.$router.push('/config/safey')
        localStorage.setItem('firstPage', '/config/safey')
      }
    },


    //短信验证码
    async smsVerificationCodeAsync(val) {
      let { status, data, message, errors } = await smsVerificationCode(val);
      if (status) {
        if (this.isMobile) {
          Notify({ type: 'success', message: message });
        } else {
          if (this.isMobile) {
            Notify({ type: 'success', message: message });
          } else {
            this.$message.success(message)
          }
        }

        this.resetPswCodeKey = data

        setTimeout(() => {
          this.handleClickCode()
          this.vantDia = false
          let time = 59;
          this.vCodetime = time
          let timer = setInterval(() => {
            // console.log(this.activeName);
            if (time == 0) {
              clearInterval(timer);
              // this.disabled = false;
              this.isVantDia = false
              this.loginCode = "获取验证码";
            } else {
              this.loginCode = time + '秒后重试'
              time--
              this.vCodetime = time

            }
          }, 1000)
        }, 1000);
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        if (this.isMobile) {
          Notify({ type: 'danger', message: message + errortext });
        } else {
          this.$message.error({ message: message + errortext });
        }
        this.isVantDia = false
        this.vantDia = false
      }
    },

    //重置密码
    async resetPasswordAsync(val) {
      let { status, data, message, errors } = await resetPassword(val);
      if (status) {
        if (this.isMobile) {
          Notify({ type: 'success', message: '修改成功！' });
        } else {
          this.$message.success('修改成功！')
        }
        this.changeForget()

        this.userforget = {
          usernameforget: '',
          pswforget: '',
          pswsureforget: ''
        }

        this.user = {
          username: '',
          psw: ''
        }

        this.errorFlag = false
        this.noLoginFlag = false
        // let value = {
        //   password: val.password,
        //   userName: val.mobile
        // };
        // this.getTokenAsync(value);
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        if (this.isMobile) {
          Notify({ type: 'danger', message: message + errortext });
        } else {
          this.$message.error({ message: message + errortext });
        }

      }
    },



    //获取用户token
    async getTokenAsync(val) {
      let { status, data, message, errors } = await getUserToken(val);
      if (this.simple) {
        if (!status) {
          let errortext = ''
          for (const key in errors) {
            errortext += errors[key]
          }
          if (this.isMobile) {
            Notify({ type: 'danger', message: message + errortext });
          } else {
            this.$message.error({ message: message + errortext });
          }
        }
      }
      // console.log(message.indexOf("用户名或密码错误"));
      if (message.indexOf("用户名或密码错误") != -1) {
        if (this.isMobile) {
          Notify({ type: 'danger', message: message });
        } else {
          this.errorFlag = true
          this.noLoginFlag = false
        }
      } else {
        if (!status) {
          if (this.isMobile) {
            Notify({ type: 'danger', message: message });
          } else {
            this.$message.error({ message: message });
          }
        } else
          if (data.roleIds == '' && data.powers[0] !== 'admin') {
            if (this.isMobile) {
              Notify({ type: 'danger', message: '很抱歉，您没有登录权限' });
            } else {
              this.$message.error('很抱歉，您没有登录权限')
            }
            this.noLoginFlag = true
            this.errorFlag = false
          } else if (data.powers.indexOf('allowLogin') === -1 && data.powers[0] !== 'admin') {
            if (this.isMobile) {
              Notify({ type: 'danger', message: '很抱歉，您没有登录权限' });
            } else {
              this.$message.error('很抱歉，您没有登录权限')
            }
            this.noLoginFlag = true
            this.errorFlag = false
          } else if (data.status === 0) {
            if (this.isMobile) {
              Notify({ type: 'danger', message: '很抱歉，您没有登录权限' });
            } else {
              this.$message.error('很抱歉，您没有登录权限')
            }
            this.noLoginFlag = true
            this.errorFlag = false
          } else {
            this.errorFlag = false
            this.setLoginInfo(data)
            this.setToken(data.token)
            this.setCreateUid(data.id)

            localStorage.setItem('token', JSON.stringify(data.token))
            localStorage.setItem('createUid', data.id)
            let libData = await listLib({ pageSize: 200 });
            let libList = []
            if (libData.status) {
              for (let i = 0; i < libData.data.length; i++) {
                if (libData.data[i].status === 1) {
                  libList.push('lib-' + libData.data[i].id)
                  if(libData.data[i].children.length > 0){
                    for (let j = 0; j < libData.data[i].children.length; j++) {
                      libList.push('lib-' + libData.data[i].id + '-' + libData.data[i].children[j].id)
                    }
                  }
                }
              }
            } else {
              if (this.isMobile) {
                Notify({ type: 'danger', message: libData.message });
              } else {
                this.$message.error(libData.message)
              }
            }
            if (data.powers[0] === 'admin') {
              let powersMy = [
                'allowLogin',
                'mySetting',
                'desktopAuthor',
                'appointPictureNeed',
                'browseUnPicture',
                'allowMyGallery',
                'createAtlas',
                'openLocalDisk',
                'allowGalleryCenter',
                'advSearchPicture',
                'baseSearchPicture',
                'selectPicture',
                'allowApply',
                'pictureDownload',
                'picturePush',
                'pictureShare',
                'allowTransmit',
                'browseDownload',
                'browsePush',
                'browseShare',
                'allowGather',
                'manageAllPictureActivity',
                'manageAllPictureNeed',
                'myPictureActivity',
                'myPictureNeed',
                'activityThemeConfig',
                'baseConfig',
                'libConfig',
                'pushConfig',
                'roleConfig',
                'systemLogs',
                'manageAtlas',
                'myFace',
                'browseActivityArticle',
                'manageActivityArticle',
                'manageAllActivityArticle',
                'myAtlas',
                'checkUserAuthInfo',
                'searchUserAuthInfo',
                'outputUserAuthInfo',
                'checkPictureArticle',
                'myPictureArticleFilter',
                'manageAllPictureArticleFilter',
                'outputPictureArticleFilter',
                'checkPictureArticleFilter',
                'rejectPictureArticleFilter',
                'userConfig',
                'textConfig',

                'createPrivateAtlas',
                'createPublicAtlas',

                'allowAiCenter',
                'securityConfig',
                'dataAnalysis',
                'manageIntelligentNode',
                'allowOperationCenter',
                'manageNas',
                'manageThirdPartyAccess',
                'operationCommand',
                'systemLogs',
                'browseWebsiteCarousel',
                'manageWebsiteCarousel',
                'browseWebsiteInfo',
                'manageWebsiteInfo',
                'websiteConfig',
                'allowRecycleBin',
                'deleteCommand',
                'recoveryCommand',
                'resourceLogCenter',
                'allowOperationCustomLabel',
                'customLabelClassConfig',
                'customLabelConfig',
                'ssoConfig',
                'justAdmin'
              ]
              let myPowers = powersMy.concat(libList)
              this.setPowers(myPowers)
              if (this.isMobile) {
                this.$router.push('/pictureCenterMobile')
              } else {
                this.judgeFirstPage(myPowers)
              }
            } else {
              this.setPowers(data.powers)
              if (this.isMobile) {
                // console.log(this.$store.state.user.powers);
                this.$router.push('/pictureCenterMobile')
              } else {
                this.judgeFirstPage(data.powers)
              }
            }

            // this.$router.push('/container')
            if (this.isMobile) {
              Notify({ type: 'success', message: '登录成功！' });
            } else {
              this.$message.success('登录成功！')
              // setTimeout(() => {
              if(this.insideLoginConfig == 'strong'){
                if (! /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{8,}$/.test(this.user.psw.trim())) {
                  // this.$message({
                  //   message: '您的密码不安全，请您点击右上角头像修改密码？',
                  //   type: 'warning',
                  //   duration: 5000
                  // })
                  this.$store.commit('SET_IsChangePsw', true)
                  sessionStorage.setItem('isChangePsw', true)
                } else {
                  sessionStorage.setItem('isChangePsw', false)
                }
              }
              
              // }, 1000);
            }
          }


      }
    },


    //获取安全配置
    async getAppSecurityConfigAsync() {
      let { status, data, message, errors } = await getAppSecurityConfig();
      if(status){
        this.insideLoginConfig = data.insideLoginConfig || 'weak'
      }
    }
  },
  created() {
    console.log(window.location.host.indexOf('vi.jschina.com.cn') != '-1');
    if(window.location.host.indexOf('vi.jschina.com.cn') != '-1'){
      this.isZjw = true
    }


    var ua = navigator.userAgent.toLowerCase();
      if(ua.match(/MicroMessenger/i)=="micromessenger"){
        wx.miniProgram.getEnv((res)=>{
           if (res.miniprogram) {
            this.isWx = true
           } else {
            this.isWx = false
           }
        })
      }else{
        this.isWx = false
      }


    this.getAppSecurityConfigAsync()
    // this.getSimple()
    this.simple = this.isSimple


    console.log('isCustomisCustomisCustomisCustom',this.custom);


    if (this.getBrowser()) {
      this.isMobile = true
    } else {
      this.isMobile = false
    }
    this.rotationInt()

    if (localStorage.getItem("loginInfo")) {
      localStorage.removeItem("loginInfo");
      localStorage.removeItem("powers");
      sessionStorage.removeItem("roleCode");
      localStorage.removeItem("createUid");
      localStorage.removeItem("token");
    }
    console.log(this.$route.query.code);
    if (this.$route.query.code) {
      this.scanAsync({
        code: this.$route.query.code
      })
    }

    if(this.$route.query.user){
      let userInfo = JSON.parse(this.$route.query.user)
      this.setLoginInfo(userInfo)
      this.setToken(userInfo.token)
      this.setCreateUid(userInfo.id)
      this.setPowers(userInfo.powers)
      localStorage.setItem('token', userInfo.token)
      localStorage.setItem('createUid', userInfo.id)
      sessionStorage.setItem('isChangePsw', false)
      this.$router.push('/pictureCenterMobile')
    }
  },
  mounted() {

  }


};
</script>

<style lang="scss" scoped>
@import "./style.scss";

a {
  font-size: 14px;
  color: white;
  text-decoration: none;
} //未访问：蓝色、无下划线

a:visited {
  color: purple;
} //已访问：紫色、无下划线
a:hover {
  color: red;
  // text-decoration: underline;
} //鼠标移近：红色、下划线
</style>

